// Bloc mairie : indique si la mairie est ouverte aujourd'hui, à partir du tableau des permanences.
const JOURS = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];

export default function mairie() {
    const ligne = document.getElementById("mairie-now");
    const table = document.getElementById("mairie-hours");
    if (!ligne || !table) return;

    const jour = JOURS[new Date().getDay()];
    const rangee = [...table.querySelectorAll("tr")].find((tr) => {
        const th = tr.querySelector("th");
        return th && th.textContent.trim().toLowerCase().startsWith(jour);
    });

    const texte = ligne.querySelector("span");
    if (rangee) {
        texte.textContent = "Ouverte aujourd'hui : " + rangee.querySelector("td").textContent.trim();
        rangee.classList.add("aujourdhui");
    } else {
        texte.textContent = "Fermée aujourd'hui";
        ligne.classList.add("ferme");
    }
    ligne.hidden = false;
}
